import { useMemo } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";
import IRumah123 from "assets/i-rumah123.png";
import ILamudi from "assets/i-lamudi.png";
import IBeliRumah from "assets/i-beli-rumah.png";

const ModalHubungkanAkun = ({
  onSelect,
  onClose,
  isOpen,
  listAkunHubungkanData,
  onDelete,
  isLoadingListAkunHubungkan,
  ...props
}) => {
  const DATA = useMemo(() => {
    return [
      {
        icon: IRumah123,
        name: "rumah123",
        endpoint: "",
        is_active: listAkunHubungkanData?.is_rumah123,
      },
      {
        icon: ILamudi,
        name: "Lamudi",
        endpoint: "",
        is_active: listAkunHubungkanData?.is_lamudi,
      },
      {
        icon: IBeliRumah,
        name: "BeliRumah.co",
        endpoint: "",
        is_active: listAkunHubungkanData?.is_belirumah,
      },
    ];
  }, [listAkunHubungkanData]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[426px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <p className="text-[17px] font-inter-semibold">Akun Terhubung</p>
          <XIcon onClick={onClose} />
        </div>

        <div className="bg-[#E6E7E8] py-2 px-4 flex flex-col gap-2">
          {DATA.map((item, index) => (
            <div
              key={`${item.name}-${index}`}
              className="bg-white px-[12px] w-full rounded-[4px]"
            >
              <div className="py-2 mb-1 flex items-center justify-between gap-2 border-b-[0.5px] border-dashed border-[#D8D8D9]">
                <div className="flex items-center gap-2">
                  <img
                    className="h-[20px] object-contain"
                    src={item.icon}
                    alt={item.name}
                  />
                  {item.is_active && (
                    <span className="text-[#2D7649] font-inter text-[11px] px-2 py-[1px] rounded-[4px] bg-[#ECF6F0]">
                      Terhubung
                    </span>
                  )}
                </div>
                {!item.is_active ? <Button
                  size="s"
                  text="Hubungkan"
                  onClick={() => onSelect(item)}
                  disabled={isLoadingListAkunHubungkan}
                /> : <Button
                  size="s"
                  type="negative"
                  text="Putuskan"
                  onClick={() => onDelete(item)}
                  disabled={isLoadingListAkunHubungkan}
                />}
              </div>
              <p className={`py-0.5 text-[11px] font-inter italic text-[#808285] leading-[17.798px] tracking-[-0.4px] ${item.is_active ? "line-through" : ""}`}>
                Siapkan alamat email akun {item.name} untuk menghubungkan.
              </p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalHubungkanAkun isOpen={isOpen} {...props} />;
};

export default Wrapper;
